export const formatDateToISO = (dateString: Date): string => {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};
